import React from 'react';
import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';

export interface CheckboxProps {
  label?: string;
  onValueChange: (value: boolean) => void;
  value?: any;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  onValueChange,
  value,
  disabled = false,
}) => {
  const isChecked =
    value === true ||
    value === '1' ||
    value === 1 ||
    value === 'true';

  const toggleSwitch = () => {
    if (!disabled) {
      onValueChange(!isChecked);
    }
  };

  return (
    <TouchableOpacity
      onPress={toggleSwitch}
      disabled={disabled}
      activeOpacity={disabled ? 1 : 0.7}
      style={[styles.container, disabled && styles.disabled]}>
      {Boolean(label && label.trim().length > 0) && (
        <Text style={[styles.label, disabled && styles.disabledText]}>
          {label}
        </Text>
      )}
      <View
        style={[
          styles.switch,
          isChecked ? styles.switchOn : styles.switchOff,
        ]}>
        <View
          style={[
            styles.switchHandle,
            isChecked ? styles.handleOn : styles.handleOff,
          ]}
        />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    fontSize: 16,
    marginRight: 8,
  },
  disabled: {
    opacity: 0.5,
  },
  disabledText: {
    color: '#888',
  },
  switch: {
    width: 50,
    height: 25,
    borderRadius: 25,
    justifyContent: 'center',
    padding: 3,
  },
  switchOn: {
    backgroundColor: '#4CD964',
  },
  switchOff: {
    backgroundColor: '#ccc',
  },
  switchHandle: {
    width: 20,
    height: 20,
    borderRadius: 20,
  },
  handleOn: {
    alignSelf: 'flex-end',
    backgroundColor: '#fff',
  },
  handleOff: {
    alignSelf: 'flex-start',
    backgroundColor: '#fff',
  },
});

export default Checkbox;
